import React from "react";

import {
  RoundQuantityPicker,
  IRoundQuantityPickerProps,
} from "@faire/retailer/components/RoundQuantityPicker";
import { IRoundQuantityPickerStateProps } from "@faire/retailer/components/RoundQuantityPicker/UseRoundQuantityPickerState";

export const ProductTileRoundQuantityOptionPicker: React.FC<
  IRoundQuantityPickerProps & IRoundQuantityPickerStateProps
> = (props) => {
  const [value, setValue] = React.useState(props.value);

  const prevPropValue = React.useRef<number>(props.value);
  if (props.value !== prevPropValue.current) {
    setValue(props.value);
    prevPropValue.current = props.value;
  }

  const onValueChange = (newValue: number) => {
    setValue(newValue);
    if (
      (props.maxValue && props.maxValue !== 0 && newValue <= props.maxValue) ||
      props.maxValue === undefined
    ) {
      props.onChange(newValue);
    }
  };

  return (
    <RoundQuantityPicker
      {...props}
      value={props.isMultiOption ? props.value : value}
      onChange={onValueChange}
    />
  );
};
